export default __webpack_public_path__ + "static/media/Flecha_down.e72f12ef.svg";